import request from '@/plugins/request';
import { IErrorResult } from '@/types/dto';
import utils from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

const $url = '/my/create';
const $urlPay = '/my/create/actions/pay';
const $urlQuery = '/my/create/actions/query';

interface IGetRequest {
  themeUserName: string;
  themeName: string;
}

interface IGetResult {
  themePreviewUrl: string;
  themePrice: number;
  themeDiscountStarter: number;
  themeDiscountStandard: number;
  themeDiscountProfessional: number;
  priceStarter: number;
  priceStandard: number;
  priceProfessional: number;
  discount1Year: number;
  discount2Year: number;
  discount3Year: number;
  discount4Year: number;
  discount5Year: number;
}

interface IPayRequest {
  hostType: string;
  year: number;
  isHongKong: boolean;
  themeUserName: string;
  themeName: string;
  channel: string;
  amount: number;
}

interface IPayResult {
  orderNo: string;
  qrCodeUrl: string;
}

interface IQueryRequest {
  orderNo: string;
}

interface IQueryResult {
  isPurchased: boolean;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, { params: req })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  pay(req: IPayRequest, success: (res: IPayResult) => void, failure: (error: AxiosError<IErrorResult> | string) => void) {
    utils.loading(true);
    request
      .post($urlPay, req)
      .then((response: AxiosResponse<IPayResult>) => {
        success(response.data);
        utils.loading(false);
      })
      .catch(error => {
        failure(error);
      });
  },

  query(req: IQueryRequest, success: (res: IQueryResult) => void) {
    request
      .post($urlQuery, req)
      .then((response: AxiosResponse<IQueryResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },
};
